/* Error handling & common function validation helpers */

export class Errors {
    public static getError(moduleName: string, functionName: string, error: string) {
        // Return an error message
        return `${moduleName}.${functionName}() Error: ${error}`;
    }

    public static ensureRequiredArgument(moduleName: string, functionName: string, argName: string, argValue: any) {
        // Throw exception for missing argument values
        if (!moduleName) { throw(Errors.getError('Errors', 'ensureRequiredArgument', 'required moduleName argument is missing or empty')); }
        if (!functionName) { throw(Errors.getError(moduleName, 'ensureRequiredArgument', 'required functionName argument is missing or empty')); }
        if (!argName) { throw(Errors.getError(moduleName, functionName, 'required argName argument is missing or empty')); }

        if (!argValue) { throw(Errors.getError(moduleName, functionName, `required ${argName} argument is missing or empty`)); }
    }
}



// WEBPACK FOOTER //
// ./src/common/errors.tsx